<!--
  Client Portal v2: the shared 3-band legend (PR D).

  A single legend reused by every banded chart so a reader learns the
  budget / allowance / external color key once. Colors come from the
  canonical BAND_DEFS (bandColors.js), which pull ThreadFlow design tokens.
-->
<template>
  <div class="band-legend" data-testid="band-legend">
    <span
      v-for="band in bands"
      :key="band.key"
      class="band-legend__item"
      :data-testid="`band-legend-${band.key}`"
    >
      <span
        class="band-legend__swatch"
        :style="{ backgroundColor: band.color }"
      />
      {{ band.label }}
    </span>
  </div>
</template>

<script>
import { BAND_DEFS } from "./bandColors";

export default {
  name: "BandLegend",
  data() {
    return { bands: BAND_DEFS };
  },
};
</script>

<style scoped>
.band-legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tf-sp-4, 16px);
  align-items: center;
  font-size: 0.8125rem;
  color: var(--tf-fg-3, #616161);
}
.band-legend__item {
  display: inline-flex;
  align-items: center;
  gap: var(--tf-sp-2, 8px);
}
.band-legend__swatch {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: var(--tf-radius-xs, 4px);
}
</style>
